<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <!-- Case Form in Biobank Module -->
    <widget-component v-for="(widgetMetadata, index) in formData.widgets"
      :key="index"
      :widgetMetadata="widgetMetadata">
    </widget-component>
    <!-- Project Code Panel with list of specimen -->
    <v-expansion-panels v-if="caseNumber">
      <v-container fluid>
        <!-- Panel for List -->
        <v-expansion-panel
          v-for="(protocolNumber, i) in caseNumber.protocolNumbers"
          :key="`pn${i}`"
        >
          <v-expansion-panel-header>
            {{ protocolNumber.protocolNumber }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-data-table
              :headers="tableMetadata.headers"
              :items="protocolNumber.specimens"
              :items-per-page="10"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>Specimens</v-toolbar-title>
                  <!-- <v-divider
                    class="mx-4"
                    inset
                    vertical
                  >
                  </v-divider> -->
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    dark
                    text
                    class="mb-2"
                    @click="onShowAddProtocolNumberSpecimen(protocolNumber)"
                  >
                    <v-icon>mdi-plus</v-icon>
                    New Specimen
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  v-for="(action, i) in tableMetadata.actions"
                  :key="`btn${i}`"
                  text
                  small
                  @click="action.onClick(item, protocolNumber)"
                >
                  <v-icon
                    class="mr-2"
                    :color="action.color"
                  >
                    {{ action.icon }}
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-container>
    </v-expansion-panels>
    <!-- specimen details -->
    <v-dialog
      v-model="dialog.showSpecimenDetails"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog.showSpecimenDetails = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ selectedProtocolNumber.protocolNumber }} ::
            {{ selectedSpecimen.code }} ::
            Details
          </v-toolbar-title>
        </v-toolbar>
        <br>
        <v-container>
          <v-list>
            <!-- <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ sampleFrom.find(sf => sf.code === selectedSpecimen.sampleFrom)?.label }}
                </v-list-item-title>
                <v-list-item-subtitle>From</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ selectedSpecimen.specimenSource?.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Specimen Source</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ selectedSpecimen.sampleFrom?.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Method of Collection</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ selectedSpecimen.specimenType?.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Specimen Type</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ selectedSpecimen.specimenState?.name }}
                </v-list-item-title>
                <v-list-item-subtitle>Preparation</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Location
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.freezer }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Freezer No.</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.temperature }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Temperature</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.shelfNumber }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Shelf No.</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.rackNumber }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Rack No.</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.slidingRackNumber }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Sliding Rack No.</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.boxNumber }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Box Number</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ selectedSpecimen.location?.boxLocation }}
                          </v-list-item-title>
                          <v-list-item-subtitle>Box Location</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="selectedSpecimen.barcode?.url">
              <v-list-item-content>
                <v-list-item-title>
                  <img
                    :src="selectedSpecimen.barcode.url"
                    style="max-width: 800px; max-height: 400px;"
                  />
                </v-list-item-title>
                <v-list-item-subtitle>Barcode</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <h2>Transactions</h2>
          <v-data-table
            :headers="transactionTableMetadata.headers"
            :items="selectedSpecimen.transactions"
            :items-per-page="5"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Transactions</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  text
                  class="mb-2"
                  @click="onOpenTransactionForm()"
                >
                  <v-icon>mdi-plus</v-icon>
                  New Transaction
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                v-for="(action, i) in transactionTableMetadata.actions"
                :key="`btn${i}`"
                text
                small
                @click="action.onClick(selectedSpecimen, item)"
              >
                <v-icon
                  class="mr-2"
                  :color="action.color"
                >
                  {{ action.icon }}
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>

          <v-dialog
            v-model="dialog.showTransaction"
            max-width="600"
            persistent
          >
            <v-card>
              <v-card-title class="text-h5">
                Transaction
              </v-card-title>
              <loader :isLoading="isLoadingSpecimen"></loader>
              <form-component
                v-if="dialog.showTransaction"
                ref="specimenTransactionForm"
                :formData="transactionFormData"
              >
              </form-component>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn
                    text
                    @click="onHideTransactionForm()"
                  >
                    Cancel
                  </v-btn>

                  <!-- <v-btn
                    color="primary darken-1"
                    text
                    @click="dialog.showTransaction = false"
                  >
                    Save
                  </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Add your table here -->
        </v-container>
      </v-card>
    </v-dialog>
    <!-- form upsert protocol number -->
    <v-dialog
      v-model="dialog.upsertSpecimen"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog.upsertSpecimen = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ selectedProtocolNumber.protocolNumber }} ::
            <span v-if="!specimenFormData.model">
              Create
            </span>
            <span v-if="specimenFormData.model">
              {{ specimenFormData.model.code }} :: Edit
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="onClickSpecimenSave()"
            >
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <br>
        <loader :isLoading="isLoadingSpecimen"></loader>
        <form-component
          v-if="dialog.upsertSpecimen"
          ref="specimenForm"
          :formData="specimenFormData"
        >
          <template #additional-info-section>
            <div class="specimen-info-container">
              <label class="specimen-info-label"> Specimen Additional Info (If Applicable) </label>
              <nested-question
                  v-if="caughtInfoValues?.length"
                  :display="'main'"
                  :questionsMetadata="{
                      questionRawList: questionsMetadata.questionRawList,
                      questionList: questionsMetadata.questionList,
                      widgets: questionsMetadata.widgets,
                      parentWidget: questionsMetadata.widgets,
                      catchValue: questionsMetadata.catchValue,
                  }"
                >
              </nested-question>
              <v-btn
                color="primary"
                dark
                block
                text
                class="add-info-button"
                @click="onClickAddInfo()"
              >
                <v-icon>mdi-plus</v-icon>
                Add Specimen info
              </v-btn>
            </div>
          </template>
          <v-btn
              color='primary'
              depressed
              clearable
              type="button"
              @click="onClickSpecimenSave()"
            >
              Save
          </v-btn>
        </form-component>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<!-- eslint-disable no-underscore-dangle -->
<script>
import phil from 'phil-reg-prov-mun-brgy';
import { Subject } from 'rxjs';
import Loader from '../../../components/utilities/Loader.vue';
import WidgetComponent from '../../../components/ui/WidgetComponent.vue';
import FormService from '../../../services/medical_registry/form.service';

import FormComponent from '../../../components/ui/FormComponent.vue';

import NestedQuestion from '../specimen/components/NestedQuestion.vue';

import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry, medicalRegistry, collectingInstitutionRegistry } = services;

const {
  caseService,
  caseSpecimenService,
  specimenTypeService,
  specimenStateService,
  caseSpecimenTransactionService,
  methodOfCollectionService,
  freezerService,
  boxService,
  specimenAdditionalInfoService,
} = biobankRegistry;

const { specimenSourceService } = medicalRegistry;
const { collectingInstitutionService } = collectingInstitutionRegistry;

export default {
  name: 'case-form',
  components: {
    Loader,
    FormComponent,
    WidgetComponent,
    NestedQuestion,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    caseNumber: Object,
  },
  data() {
    // const sampleFrom = [
    //   {
    //     label: 'Biopsy',
    //     code: '63392b88000000000041812f',
    //   },
    //   {
    //     label: 'Mastetctomy',
    //     code: '63392b9f0000000000418130',
    //   },
    // ];
    return {
      isLoadingSpecimen: false,
      dialog: {
        upsertSpecimen: false,
        showSpecimenDetails: false,
        showTransaction: false,
      },
      selectedQuestion: '',
      selectedProtocolNumber: {
        protocolNumber: '',
      },
      selectedSpecimen: {
        code: '',
      },
      boxLocationInitial: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      philRegions: [],
      philProvinces: [],
      caughtInfoValues: [],
      questionsMetadata: {
        questionRawList: [],
        questionList: [],
        widgets: [],
      },
      questionListSubject: new Subject(),
      tab: null,
      specimenFormData: {
        model: null,
        onSubmit: () => {},
        widgets: [
          {
            type: 'text',
            name: 'code',
            label: 'Specimen Code',
            value: '',
            counter: 100,
            maxLength: 100,
            rules: [
              (v) => !!v || 'Sample Code is required',
            ],
          },
          {
            type: 'text',
            name: 'caseNumberSpecimenSource',
            label: 'Specimen Source',
            placeholder: 'Select where the specimen came from',
            readonly: true,
            value: '',
          },
          {
            type: 'select',
            name: 'sampleFrom',
            label: 'Method of Collection',
            placeholder: 'Select Method of collection',
            multiple: false,
            rules: [
              (v) => !!v || 'Method of collection is required',
            ],
            items: [],
            value: '',
          },
          {
            type: 'select',
            name: 'specimenType',
            label: 'Specimen Type',
            placeholder: 'Select where the specimen came from',
            multiple: false,
            rules: [
              (v) => !!v || 'Specimen Type is required',
            ],
            items: [
              {
                label: 'Blood',
                code: '630cf042e5b54f0138f7b1cd',
              },
              {
                label: 'Urine',
                code: '632d96ba43c7bf920b027833',
              },
            ],
            value: '',
          },
          {
            type: 'select',
            name: 'specimenState',
            label: 'Preparation',
            placeholder: 'Select preparation',
            multiple: false,
            rules: [
              (v) => !!v || 'Preparation is required',
            ],
            items: [
              {
                label: 'Frozen',
                code: '630ccdf89eb0efca5a34e01b',
              },
            ],
            value: '',
          },
          // backup for PGH update implementation
          // {
          //   type: 'text',
          //   name: 'freezer',
          //   label: 'Freezer Number',
          //   value: '',
          //   placeholder: '',
          //   rules: [
          //     (v) => !!v || 'Freezer number is required',
          //     this.noSpecialCharsRule,
          //   ],
          // },
          {
            type: 'select',
            name: 'boxNumber',
            label: 'Box Number',
            multiple: false,
            // selectChange: (selectedValue) => this.setBoxNumbers(selectedValue),
            rules: [
              (v) => !!v || 'Box Number is required',
            ],
            items: [],
            value: '',
          },
          // {
          //   type: 'select',
          //   name: 'freezer',
          //   label: 'Select Freezer',
          //   multiple: false,
          //   placeholder: '',
          //   selectChange: () => this.displayTemperature(),
          //   rules: [
          //     (v) => !!v || 'Freezer is required',
          //   ],
          //   items: [],
          //   value: '',
          // },
          {
            type: 'select',
            name: 'freezer',
            label: 'Select Freezer',
            // selectChange: (data) => this.testFreezer(data),
            value: '',
            items: [],
            readonly: true,
          },
          {
            type: 'text',
            name: 'temperature',
            label: 'Temperature',
            value: '',
            readonly: true,
          },
          {
            type: 'text',
            name: 'shelfNumber',
            label: 'Shelf Number',
            multiple: false,
            // selectChange: () => this.setBoxNumbers(),
            rules: [
              (v) => !!v || 'Shelf Number is required',
            ],
            items: [],
            value: '',
            readonly: true,
          },
          {
            type: 'text',
            name: 'rackNumber',
            label: 'Rack Number',
            multiple: false,
            // selectChange: () => this.setBoxNumbers(),
            rules: [
              (v) => !!v || 'Rack Number is required',
            ],
            items: [],
            value: '',
            readonly: true,
          },
          {
            type: 'text',
            name: 'slidingRackNumber',
            label: 'Sliding Rack Number',
            multiple: false,
            placeholder: '',
            // selectChange: () => this.setBoxNumbers(),
            rules: [
              (v) => !!v || 'Sliding Rack Number is required',
            ],
            items: [],
            value: '',
            readonly: true,
          },
          {
            type: 'select',
            name: 'boxLocation',
            label: 'Box Location',
            multiple: false,
            placeholder: '',
            rules: [
              (v) => !!v || 'Box Number is required',
            ],
            items: [],
            value: '',
          },
          {
            type: 'select',
            name: 'siteOfCollection',
            label: 'Collecting Institution',
            counter: 200,
            maxLength: 200,
            items: [],
            value: '',
          },
          {
            type: 'text', // display all data first
            name: 'region',
            label: 'Site of Collection (Region)',
            placeholder: 'Select a Collecting Institution first',
            readonly: true,
            value: '',
          },
          {
            type: 'text', // display all data first
            name: 'province',
            label: 'Site of Collection (Province)',
            placeholder: 'Select a Collecting Institution first',
            readonly: true,
            value: '',
          },
          {
            type: 'date',
            label: 'Date of Collection',
            name: 'dateOfCollection',
            placeholder: 'Define the date of collection',
            customStyle: {
              margin: '-10px 0px 20px 0px',
            },
            value: '',
            range: false,
          },
          {
            type: 'file',
            name: 'barcodeAttachment',
            label: '',
            multiple: false,
            accept: '.png',
            imageURL: null,
            value: null,
          },
          {
            type: 'anchor',
            id: 'additional-info-section',
          },
          {
            type: 'textarea',
            name: 'note',
            label: 'note',
            value: '',
            counter: 500,
            maxLength: 500,
            rules: [],
          },
          // modified all fields that connects here
          // {
          //   type: 'button',
          //   btnType: 'button',
          //   name: 'save',
          //   label: 'Save',
          //   color: 'primary',
          //   onClick: async () => {
          //     // add conditional condition
          //     this.onClickSpecimenSave();
          //   },
          //   value: null,
          // },
        ],
      },
      transactionFormData: {
        model: null,
        onSubmit: () => {},
        widgets: [
          {
            type: 'select',
            name: 'status',
            label: 'Status',
            placeholder: 'Select the status of specimen',
            multiple: false,
            rules: [
              (v) => !!v || 'Status is required',
            ],
            items: [
              {
                label: 'Discard',
                code: '6359892e0000000000f3e280',
              },
              {
                label: 'New Consent Form',
                code: '6329f91c0000000000eb130e',
              },
              {
                label: 'New Institution',
                code: '635989450000000000f3e281',
              },
            ],
            value: '',
          },
          {
            type: 'textarea',
            name: 'note',
            label: 'Notes',
            value: '',
            counter: 255,
            maxLength: 255,
            rules: [
              (v) => !!v || 'Status is required',
            ],
          },
          {
            type: 'button',
            btnType: 'button',
            name: 'save',
            label: 'Save',
            color: 'primary',
            onClick: async () => {
              this.onClickSpecimenTransactionSave(this.selectedSpecimen);
            },
            value: null,
          },
        ],
      },
      formData: {
        onSubmit: this.onSubmit,
        model: this.caseNumber,
        widgets: [
          {
            type: 'select',
            name: 'caseNumber',
            label: 'Case Number',
            placeholder: 'Select a case number',
            multiple: false,
            readonly: false,
            rules: [
              (v) => !!v || 'Case number is required',
            ],
            items: [],
            customFilter: (item, queryText) => {
              const label = item.label.toLowerCase();
              const searchText = queryText.toLowerCase();
              return label.indexOf(searchText) > -1;
            },
            value: '',
          },
        ],
      },
      transactionTableMetadata: {
        headers: [
          {
            text: 'Action',
            value: 'status.name',
          },
          {
            text: 'Date Performed',
            value: '_metadata.updated.date',
          },
          {
            text: 'User',
            value: '_metadata.updated.user.fullName',
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
          },
        ],
        actions: [
          {
            icon: 'mdi-delete',
            color: 'primary',
            onClick: (specimen, transaction) => {
              this.onClickRemoveSpecimenTransaction(specimen, transaction);
            },
          },
          {
            icon: 'mdi-pencil',
            color: 'pink',
            onClick: (specimen, transaction) => {
              this.onClickEditSpecimenTransaction(specimen, transaction);
            },
          },
          // {
          //   icon: 'mdi-eye',
          //   color: 'blue',
          //   onClick: (item) => console.log(item, 'lmao 3'),
          // },
        ],
      },
      tableMetadata: {
        headers: [
          {
            text: 'Specimen Code',
            align: 'start',
            value: 'code',
          },
          {
            text: 'Specimen Type',
            value: 'specimenType.name',
          },
          {
            text: 'Preparation',
            value: 'specimenState.name',
          },
          {
            text: 'Date',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
          },
        ],
        actions: [
          {
            icon: 'mdi-delete',
            color: 'primary',
            onClick: (specimen, protocolNumber) => this.onClickRemoveSpecimen(
              specimen,
              protocolNumber,
            ),
          },
          {
            icon: 'mdi-pencil',
            color: 'pink',
            onClick: (specimen, protocolNumber) => this.onEditSpecimenDetails(
              specimen,
              protocolNumber,
            ),
          },
          {
            icon: 'mdi-eye',
            color: 'blue',
            onClick: (specimen, protocolNumber) => this.onShowSpecimenDetails(
              specimen,
              protocolNumber,
            ),
          },
        ],
      },
    };
  },
  async created() {
    const caseNumberWidget = this.formData
      .widgets
      .find((w) => w.name === 'caseNumber');
    if (this.caseNumber?._id) {
      caseNumberWidget.value = this.caseNumber._id;
      caseNumberWidget.readonly = true;
    }
    const prepareSpecimen = async ({ name, dataSource }) => {
      const data = await dataSource();
      const widget = this.specimenFormData.widgets.find((w) => w.name === name);
      widget.items = data.map((doc) => ({ code: doc._id, label: doc.name }));
    };

    // set the regions here.

    this.philRegions = phil.regions;
    this.philProvinces = phil.provinces;
    prepareSpecimen({ name: 'specimenType', dataSource: () => specimenTypeService.getList() });
    prepareSpecimen({ name: 'specimenState', dataSource: () => specimenStateService.getList() });
    prepareSpecimen({ name: 'sampleFrom', dataSource: () => methodOfCollectionService.getList() });
    prepareSpecimen({ name: 'freezer', dataSource: () => freezerService.getList() });
    prepareSpecimen({ name: 'boxNumber', dataSource: () => boxService.getList() });
    prepareSpecimen({ name: 'siteOfCollection', dataSource: () => collectingInstitutionService.getList() });

    const cases = await caseService.getList();
    caseNumberWidget.items = cases
      .map((document) => ({ code: document._id, label: document.caseNumber }));
    // on barcode change display preview
    const barcodeAttachment = this.getFormValue('barcodeAttachment');
    barcodeAttachment.onFileChange = (e, imageURL) => {
      if (e?.length > 0) {
        const file = e[0];
        barcodeAttachment.imageURL = URL.createObjectURL(file);
      } else {
        barcodeAttachment.imageURL = imageURL;
      }
    };
    // this.specimenFormData.widgets = this.specimenFormData.widgets.map((fd) => {
    //   if (fd.name === 'dateOfCollection') {
    //     fd.value = 'Tue Aug 20 2024 08:00:00 GMT+0800 (Singapore Standard Time)';
    //   }
    //   return fd;
    // });

    // get the specimen additional info
    const questions = await specimenAdditionalInfoService.getList();

    this.questionsMetadata.questionRawList = questions;
    const selections = questions.map((q) => {
      const { _id, name, type } = q;
      return {
        label: name,
        code: _id,
        icon: FormService.getQuestionTypeIcon(type),
      };
    });
    this.questionsMetadata.questionList = selections;
    this.questionListSubject.next(selections);

    // for view only
    // const { specimenAdditionalInfo } = this.formData.model;
    // if (specimenAdditionalInfo.length > 0) {
    // } else {
    //   const basedArray = ['question'];
    //   basedArray.forEach((type, index) => {
    //     const parent = this.questionsMetadata.widgets;
    //     const widget = this.getWidget(type, parent, index);
    //     this.questionsMetadata.widgets.push(widget);
    //   });
    // }
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    async 'specimenFormData.widgets.5.value'(boxId) {
      // to render boxes
      this.setBoxNumbers(boxId);
    },
    // eslint-disable-next-line object-shorthand
    async 'specimenFormData.widgets.12.value'(id) {
      await this.setInstitutionRegProv(id);
    },
    questionsMetadata: {
      handler(newVal) {
        // apply this method to this function to enable and disable the question selection
        // onSelectChangeDisableItem(code, oldVal, source)

        // Perform some action when questionsMetadata changes
        const { widgets } = newVal;
        const infosArray = [];
        widgets.forEach((w) => {
          const { preview } = w;
          const {
            name,
            label,
            value,
          } = preview;
          // if else new val and oldval apply the onSelectChangeDisableItem
          // this.onSelectChangeDisableItem(w.value, null, 'onSelectQuestion');
          infosArray.push({
            _id: w.value,
            name: label,
            code: name,
            type: preview.type,
            display: 'question',
            answer: value,
          });
        });
        // oldVal.widgets.forEach((ow) =>
        // this.onSelectChangeDisableItem(null, ow.value, 'onSelectQuestion'));
        this.caughtInfoValues = infosArray;
      },
      deep: true, // Watch nested changes within questionsMetadata
    },
  },
  methods: {
    async setInstitutionRegProv(id) {
      const institutionDetails = await collectingInstitutionService.getOne({ id });

      const regionsWidget = this.getFormValue('region');
      const provinceWidget = this.getFormValue('province');

      regionsWidget.value = this.philProvinces
        .find((province) => province.prov_code === institutionDetails.province)?.name;
      provinceWidget.value = this.philRegions
        .find((region) => region.reg_code === institutionDetails.region)?.name;
    },
    onOpenTransactionForm() {
      this.dialog.showTransaction = true;
    },
    onHideTransactionForm() {
      this.dialog.showTransaction = false;
      this.transactionFormData.model = {};
    },
    async onClickEditSpecimenTransaction(specimen, transaction) {
      const editTransaction = { ...transaction };
      editTransaction.status = transaction.status._id;
      this.transactionFormData.model = editTransaction;

      this.onOpenTransactionForm();
    },
    async onClickRemoveSpecimenTransaction(specimen, transaction) {
      this.$confirmDialog.show({
        text: `<p>Are you sure you want to permanently delete:
          <ul>
            <li><b>${transaction.status.name}</b></li>
            <li>${transaction._metadata.created.user.fullName}</li>
          </ul>
          </p>`,
        title: 'Delete Transaction',
      }, () => this.onRemoveSpecimenTransaction(specimen, transaction));
    },
    async onRemoveSpecimenTransaction(specimen, transaction) {
      this.isLoadingSpecimen = true;
      await caseSpecimenTransactionService.delete({
        specimenId: specimen._id,
        transactionId: transaction._id,
      });
      this.$snackbar.show({
        color: 'success',
        text: 'Transaction deleted successfully',
        closeColor: 'white',
      });
      const index = specimen.transactions.findIndex((t) => t._id === transaction._id);
      specimen.transactions.splice(index, 1);
      this.isLoadingSpecimen = false;
    },
    async onClickSpecimenTransactionSave(specimen) {
      const { specimenTransactionForm } = this.$refs;
      if (!specimenTransactionForm.validate()) {
        return;
      }

      this.isLoadingSpecimen = true;
      const specimenTransaction = specimenTransactionForm.dataAsJSON();

      const transaction = await caseSpecimenTransactionService.upsert({
        specimenId: specimen._id,
        transaction: specimenTransaction,
      });
      const index = specimen.transactions.findIndex((t) => t._id === transaction._id);
      if (index === -1) {
        specimen.transactions.push(transaction);
      } else {
        specimen.transactions.splice(index, 1, transaction);
      }

      const message = !specimenTransaction.id
        ? 'Transaction added successfully'
        : 'Transaction updated successfully';
      this.$snackbar.show({
        color: 'success',
        text: message,
        closeColor: 'white',
      });
      this.onHideTransactionForm();
      this.isLoadingSpecimen = false;
    },
    async onClickSpecimenSave() {
      const { specimenForm } = this.$refs;
      if (!specimenForm.validate()) {
        return;
      }
      this.isLoadingSpecimen = true;
      const formValues = this.$refs.specimenForm.dataAsJSON();
      const caseSpecimen = {
        ...formValues,
      };
      caseSpecimen.caseNumber = {
        _id: this.caseNumber._id,
      };
      caseSpecimen.protocolNumber = {
        _id: this.selectedProtocolNumber.id,
      };
      caseSpecimen.location = {
        freezer: caseSpecimen.freezer,
        shelfNumber: caseSpecimen.shelfNumber,
        rackNumber: caseSpecimen.rackNumber,
        slidingRackNumber: caseSpecimen.slidingRackNumber,
        boxLocation: caseSpecimen.boxLocation,
        boxNumber: caseSpecimen.boxNumber,
      };
      caseSpecimen.specimenAdditionalInfo = this.caughtInfoValues;

      try {
        const specimenCaseId = await (async () => {
          if (!this.specimenFormData.model) {
            const { _id, _metadata } = await caseSpecimenService.create({ specimen: caseSpecimen });

            // prepare case for display
            caseSpecimen._metadata = _metadata;
            caseSpecimen.specimenState = await specimenStateService.getOne({
              id: caseSpecimen.specimenState,
            });
            caseSpecimen.specimenType = await specimenTypeService.getOne({
              id: caseSpecimen.specimenType,
            });
            caseSpecimen.specimenSource = await specimenSourceService.getOne({
              id: caseSpecimen.specimenSource,
            });
            caseSpecimen.sampleFrom = await methodOfCollectionService.getOne({
              id: caseSpecimen.sampleFrom,
            });
            // caseSpecimen.sampleFrom = await freezerService.getOne({
            //   id: caseSpecimen.freezer,
            // });
            this.selectedProtocolNumber.specimens.push(caseSpecimen);
            this.$snackbar.showOk({ text: 'Successfully added Specimen!' });
            return _id;
          }
          caseSpecimen._metadata = this.specimenFormData.model._metadata;
          const updatedSpecimen = await caseSpecimenService.update({ specimen: caseSpecimen });
          this.$snackbar.showOk({ text: 'Successfully updated Specimen!' });
          Object.assign(this.specimenFormData.model, updatedSpecimen);
          return updatedSpecimen._id;
        })();
        const { barcodeAttachment } = caseSpecimen;
        if (barcodeAttachment) {
          const formData = new FormData();
          formData.append('attachment', barcodeAttachment[0]);
          await caseSpecimenService.uploadBarcode({ id: specimenCaseId, formData });
        }
        this.selectedProtocolNumber = {};
        this.dialog.upsertSpecimen = false;
        this.resetSpecimenForm();

        this.isLoadingSpecimen = false;
      } catch (e) {
        this.isLoadingSpecimen = false;
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
    },
    onClickRemoveSpecimen(specimen, protocolNumber) {
      this.$confirmDialog.show({
        text: `<p>Are you sure you want to permanently delete: <b>${specimen.code}</b></p>`,
        title: 'Delete Specimen',
      }, () => this.onRemoveSpecimen(specimen, protocolNumber));
    },
    async onRemoveSpecimen(specimen, protocolNumber) {
      await caseSpecimenService.delete({ specimen });
      this.$snackbar.show({
        color: 'success',
        text: 'Specimen deleted successfully',
        closeColor: 'white',
      });
      const index = protocolNumber.specimens.findIndex((sp) => sp._id === specimen._id);
      protocolNumber.specimens.splice(index, 1);
    },
    onShowAddProtocolNumberSpecimen(protocolNumber) {
      this.questionsMetadata.widgets = [];
      this.caughtInfoValues = [];
      this.resetSpecimenForm();
      this.selectedProtocolNumber = protocolNumber;
      this.dialog.upsertSpecimen = true;
    },
    async onEditSpecimenDetails(specimen, protocolNumber) {
      // for PGH data rendering (default to Human)
      this.resetSpecimenForm();
      specimen.freezer = specimen.location.freezer;
      specimen.specimenSource = await this.getExistingSpecimenSource();
      const { temperature } = await this.getFreezerData(specimen.freezer);
      specimen.temperature = temperature;
      specimen.shelfNumber = specimen.location.shelfNumber;
      specimen.rackNumber = specimen.location.rackNumber;
      specimen.slidingRackNumber = specimen.location.slidingRackNumber;
      specimen.boxLocation = specimen.location.boxLocation;
      specimen.boxNumber = specimen.location.boxNumber;

      // format the date of collection datepicker when retreiving
      // But the datepicker wont display the data
      // maybe the problem is in the execution order
      const cloned = JSON.parse(JSON.stringify(specimen));

      // restore date AFTER clone
      if (cloned.dateOfCollection) {
        cloned.dateOfCollection = new Date(cloned.dateOfCollection);
      }

      this.specimenFormData.model = cloned;

      if (specimen.barcode?._id) {
        const barcodeAttachment = this.getFormValue('barcodeAttachment');
        barcodeAttachment.label = specimen.barcode
          ? `${specimen.barcode?._id}.png`
          : '';
        const { barcode } = await caseSpecimenService.getOne({ id: specimen._id });
        barcodeAttachment.imageURL = barcode.url;
      }
      this.selectedProtocolNumber = protocolNumber;
      this.selectedSpecimen = specimen;
      // dito dapat
      this.questionsMetadata.widgets = [];
      this.caughtInfoValues = [];
      if (specimen.specimenAdditionalInfo.length > 0) {
        const questions = await specimenAdditionalInfoService.getList();
        const qParent = this.questionsMetadata.widgets;
        const goToQuestions = (question, index, parent) => {
          const { display, _id } = question;
          const widget = this.getWidget(display, parent, index);
          if (display === 'question') {
            this.onSelectChangeDisableItem(_id, null, 'init of widget');
            const questionJSON = questions.find((q) => {
              const { _id: qId } = q;
              return qId === _id;
            });
            widget.value = _id;
            widget.preview = {
              ...FormService.getValidWidgetJSON(questionJSON),
              readonly: false,
              // populate the value here
            };
            parent.push(widget);
            const matchedInfo = specimen.specimenAdditionalInfo
              .find((addedInfo) => addedInfo._id === widget.value);
            const { preview } = widget;
            preview.value = matchedInfo.answer;
          }
        };
        specimen.specimenAdditionalInfo.forEach(
          (question, index) => goToQuestions(question, index, qParent),
        );
      }
      // this.caughtInfoValues = specimen.specimenAdditionalInfo;
      this.dialog.upsertSpecimen = true;
    },
    async onShowSpecimenDetails(specimen, protocolNumber) {
      this.selectedProtocolNumber = protocolNumber;
      if (specimen.barcode?._id) {
        const { barcode } = await caseSpecimenService.getOne({ id: specimen._id });
        specimen.barcode = barcode;
      }
      this.selectedSpecimen = specimen;

      const { location } = this.selectedSpecimen;

      // set the name of freezer and its temperature
      const freezerData = await this.getFreezerData(location.freezer);
      if (Object.keys(freezerData).length) {
        location.temperature = freezerData.temperature;
        location.freezer = freezerData.name;
      }

      this.dialog.showSpecimenDetails = true;
    },
    resetSpecimenForm() {
      this.specimenFormData.model = null;
      this.specimenFormData.widgets.forEach(async (w) => {
        if (w.name === 'barcodeAttachment') {
          w.label = 'Barcode Upload';
          w.value = null;
          w.imageURL = null;
          return;
        }
        if (w.name === 'caseNumberSpecimenSource') {
          w.value = await this.getExistingSpecimenSource();
          return;
        }
        w.value = '';
      });
    },
    noSpecialCharsRule(value) {
      const pattern = /^[A-Za-z0-9\s]+$/;
      if (!pattern.test(value)) {
        return 'This field should not contain special characters.';
      }
      return true;
    },
    async getExistingSpecimenSource() {
      const existingSource = await specimenSourceService.getOne({
        id: this.caseNumber.specimenSource,
      });
      return existingSource.name;
    },
    async displayTemperature() {
      const freezer = this.getFormValue('freezer');
      const temperatureField = this.getFormValue('temperature');
      const { temperature } = await this.getFreezerData(freezer.value);
      temperatureField.value = temperature;
    },
    async getFreezerData(freezerId) {
      return freezerService.getOne({
        id: freezerId,
      });
    },
    getFormValue(inputName) {
      return this.specimenFormData
        .widgets
        .find(({ name }) => name === inputName);
    },
    async setBoxNumbers(boxData) {
      // onchange the freezer and other
      const freezers = await freezerService.getList();
      const freezerValue = this.getFormValue('freezer');
      const shelfValue = this.getFormValue('shelfNumber');
      const rackValue = this.getFormValue('rackNumber');
      const slidingRackValue = this.getFormValue('slidingRackNumber');
      const temperatureValue = this.getFormValue('temperature');

      let found = false;

      await Promise.all(
        freezers.map(async (fr) => {
          if (found || !Array.isArray(fr.boxNumbers)) return;

          const match = fr.boxNumbers.find((bn) => bn.boxId === boxData);

          if (match) {
            const { boxLocation } = match;
            freezerValue.value = fr._id;
            temperatureValue.value = fr.temperature;
            shelfValue.value = boxLocation.shelfNo;
            rackValue.value = boxLocation.rackNo;
            slidingRackValue.value = boxLocation.slidingRackNo;

            const box = await boxService.getOne({ id: boxData });
            this.setBoxLocations1(box);

            found = true;
          }
        }),
      );

      // If not found, clear all values
      if (!found) {
        freezerValue.value = null;
        temperatureValue.value = null;
        shelfValue.value = null;
        rackValue.value = null;
        slidingRackValue.value = null;
      }
    },
    setBoxLocations1(data) {
      const boxLocationProps = this.getFormValue('boxLocation');
      const storeBoxloc = [];
      for (let i = 1; i <= data.noOfColumn; i += 1) {
        for (let y = 1; y <= data.noOfRows; y += 1) {
          const t = this.boxLocationInitial[i - 1];
          storeBoxloc.push({
            code: t + y, // ex: A1, A2...
            label: t + y,
          });
        }
      }
      boxLocationProps.items = storeBoxloc;
    },
    widgetQuestion({
      questions, selections, parent, index, selectChange,
    }) {
      const widget = {
        type: 'select',
        display: 'question',
        name: 'selectedQuestion',
        label: 'Question',
        placeholder: 'Enter question',
        parent,
        index,
        conditionalWidgets: {
          isRequired: {
            type: 'switch',
            name: 'isRequired',
            label: 'Mandatory',
            value: true,
          },
        },
        multiple: false,
        value: '',
        preview: {},
        items: selections,
        rules: [
          (v) => !!v || 'Question type is required',
        ],
      };
      // eslint-disable-next-line func-names
      widget.selectChange = function (code, oldValue) {
        if (code) {
          const question = questions.find((q) => {
            const { _id } = q;
            return _id === code;
          });
          this.preview = { ...FormService.getValidWidgetJSON(question), readonly: false };
        } else {
          this.preview = {};
        }
        selectChange(code, oldValue);
      };
      return widget;
    },
    onClickAddInfo() {
      const qParent = this.questionsMetadata.widgets;
      // qParent.display = 'section';
      this.questionsMetadata.widgets.forEach((widgets) => {
        widgets.preview.readonly = false;
      });

      const widget = this.widgetQuestion({
        questions: this.questionsMetadata.questionRawList,
        selections: this.questionsMetadata.questionList,
        parent: qParent,
        index: qParent.length,
        selectChange: (value, oldVal) => this.onSelectChangeDisableItem(value, oldVal, 'onClickAdd'),
      });
      this.questionsMetadata.widgets.push(widget);
    },
    disableSelection(code, enabled) {
      const item = this.questionsMetadata.questionList.find((q) => q.code === code);
      if (enabled) {
        item.disabled = true;
      } else {
        delete item.disabled;
      }
    },
    // eslint-disable-next-line no-unused-vars
    onSelectChangeDisableItem(code, oldVal, source) {
      this.disableSelection(code, true);
      if (oldVal) {
        this.disableSelection(oldVal, false);
      }
    },
    getWidget(type, parent, index) {
      if (type === 'section') {
        return this.widgetQuestion({
          parent,
          index,
        });
      }
      return this.widgetQuestion({
        questions: this.questionsMetadata.questionRawList,
        selections: this.questionsMetadata.questionList,
        parent,
        index,
        selectChange: (value, oldVal) => this.onSelectChangeDisableItem(value, oldVal, 'selectChange'),
      });
    },
  },
};
</script>

<style scoped>
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}
.text {
  font-weight: bold;
  margin: 20px;
}
.specimen-info-label {
  font-size: 16px;
  font-weight: bold;
  color: #333; /* Darker text color for readability */
  margin-bottom: 8px; /* Space below the label */
  display: block;
}
.specimen-info-container {
  background-color: #f9f9f9; /* Soft background color */
  border: 1px solid #ddd; /* Light border for separation */
  border-radius: 6px; /* Rounded corners */
  padding: 12px 16px; /* Inner padding */
  margin-top: 10px; /* Space above the section */
  margin-bottom: 40px;
}
.add-info-button {
  color: #8b0000; /* Dark red color for the button text */
  display: inline-block;
  margin-top: 8px;
  cursor: pointer;
  text-decoration: none;
}
</style>
